import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowBackIos } from "@material-ui/icons";

// Components
import RiderMaps from "../components/RiderMaps";
import OfflineComponent from "../components/OfflineComponent";

// helpers
import { apiGet } from "../helpers/api";

const useStyles = makeStyles((theme) => ({
  appBar: {
    height: "10vh",
    backgroundColor: "#942424",
  },
  toolbar: {
    margin: "0",
    top: "50%",
    transform: "translateY(-50%)",
  },
  back: {
    color: "#fff",
    fontSize: "small",
  },
  title: {
    flexGrow: 1,
    fontWeight: "bold",
  },
  mapContainer: {
    height: "90vh",
  },
}));

function RiderLocations() {
  const classes = useStyles();

  const [riders, setRiders] = useState([]);

  useEffect(() => {
    //  fetch rider locations
    const fetchRiders = async () => {
      //   if (riders.length > 0) {
      //     return null;
      //   }

      try {
        const response = await apiGet(`/admin/riders/position`);
        setRiders(response.data.data);
      } catch (err) {
        console.log(err.response?.data?.message);
      }
    };

    fetchRiders();

    window.Echo.private("deliveries").listen(".DeliveryUpdated", () => {
      fetchRiders();
    });
  }, []);

  return (
    <>
      <OfflineComponent />
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Link href="/">
            <ArrowBackIos className={classes.back} />
          </Link>

          <Typography variant="h6" className={classes.title}>
            Rider Locations
          </Typography>
        </Toolbar>
      </AppBar>

      <div className={classes.mapContainer}>
        <RiderMaps
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API}&v=3.exp&libraries=geometry,drawing,places`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `90vh` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          riders={riders}
        />
      </div>
    </>
  );
}

export default RiderLocations;
